/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export class EmployeeModel {
  constructor(
    public employeeId: string,
    public name: string,
    public email: string,
    public userName: string,
    public employeeGroup: string[] = [],
    public startScreenConfiguration: object[] = [],
  ) {}
}
